// extracted by mini-css-extract-plugin
export var center = "_4o-2";
export var clickableRow = "_4o-5";
export var expandedRow = "_4o-7";
export var hoverable = "_4o-4";
export var left = "_4o-1";
export var right = "_4o-3";
export var row = "_4o-0";
export var selectedRow = "_4o-6";
export var summaryRow = "_4o-8";